export default {
      id: "org-notifications-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#org-notifications-usage",
      toString: function () {
        return this.url;
      }
    }